import { Mesh } from "three";
import { getBooleanPropBuilder } from "../FeatureUtils";

export type PMesh = Partial<Mesh>;

export const EnvironmentalContextPresets: Record<
  string,
  PMesh | ((userData: Record<string, any>) => PMesh)
> = {
  Shadow: getBooleanPropBuilder<PMesh>("Shadow", {
    castShadow: true,
    receiveShadow: true,
  }),
};
